module.exports = __webpack_public_path__ + "img/frame-1.d91aeee9.png";